module.exports = __webpack_public_path__ + "img/8_004.06163b39.webp";